import { FIELD_TYPES } from "../constants.js";
const isFieldsConfig = (val) => {
  if (!val || typeof val !== "object") {
    return false;
  }
  const config = val;
  return config !== null && typeof config === "object" && !Array.isArray(config) && Object.keys(config).every((key) => {
    const field = config[key];
    return typeof field === "object" && field !== null && "type" in field && typeof field.type === "string" && ("options" in field ? Array.isArray(field.options) : true) && ("default" in field ? typeof field.default === "string" : true) && ("label" in field ? typeof field.label === "string" : true) && ("description" in field ? typeof field.description === "string" : true) && ("required" in field ? typeof field.required === "boolean" : true) && ("fallback" in field ? typeof field.fallback === "string" : true) && ("width" in field ? typeof field.width === "number" : true) && ("height" in field ? typeof field.height === "number" : true);
  });
};
const isDateRange = (config) => config.type === FIELD_TYPES.dateRange;
export {
  isDateRange,
  isFieldsConfig
};
